<template>
  <div class="container quienes-somos">
    <div class="container section text-center pt-3">
      <h2>¿Quienes somos?</h2>
      <div class="row">
        <div class="col-xs-12 col-lg-6">
          <p class="text-justify">
            Sancho Pan es una empresa familiar con más de 47 años de tradición
            en la elaboración de productos de panadería, nacida en 1978 a partir
            del sueño de un joven inspirado por las enseñanzas de su madre.
          </p>
          <p class="text-justify">
            Nuestra historia comienza con Blanca García, una mujer que, entre
            harinas, aromas cálidos y tardes de esfuerzo, elaboraba pan en el
            horno de barro de su casa para alimentar a sus once hijos. Su
            dedicación y amor por la cocina dejaron una huella profunda en el
            más pequeño, Lorenzo Buendía García, quien desde muy joven soñó con
            fundar una panadería que llevara aquellos sabores caseros a todos
            los rincones de la región.
          </p>
          <p class="text-justify">
            Ese sueño se materializó en el corazón del departamento de Córdoba,
            tierra que nos recibió con los brazos abiertos, valorando el
            esfuerzo y la constancia de Lorenzo. Aunque la familia es originaria
            de los departamentos del Atlántico y Bolívar, fue en Córdoba donde
            Sancho Pan echó raíces y floreció, gracias al tesón, la calidad de
            sus productos y el compromiso con la tradición.
          </p>
          <p class="text-justify">
            Hoy, Sancho Pan representa una empresa sólida y querida en la
            región, con una propuesta basada en productos tradicionales,
            elaborados con recetas caseras y auténticas. Con orgullo, celebramos
            casi cinco décadas de historia, llevando sabor, calidez y calidad a
            los hogares, avanzando hacia el futuro bajo el liderazgo de la
            tercera generación familiar.
          </p>
        </div>
        <div class="col-xs-12 col-lg-6">
          <img v-lazy="'img/brand_sanchopan_big.png'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "quienesSomos",
};
</script>
<style>
.quienes-somos {
  min-height: calc(100vh - 200px);
}
</style>
